import { UserAddress } from "@/types";
import { deleteData, getData } from "./axios-service";

function modelMapper(inputAddress: any): UserAddress {
    return {
        id: inputAddress.id,
        isDefault: inputAddress.isDefault,
        geoAddressId: inputAddress.geoAddressId,
        line1: inputAddress.line1,
        line2: inputAddress.line2,
        city: inputAddress.city,
        postalCode: inputAddress.postalCode,
        longitude: inputAddress.longitude,
        latitude: inputAddress.latitude
    };
}

export function modelMapperArray(inputArray: any[]): UserAddress[] {
    return inputArray.map(modelMapper);
}

export async function fetchAllUserAddresses(userId: string): Promise<UserAddress[]> {
    const userAddresses = await getData<UserAddress[]>("/users/" + userId + "/addresses");
    return modelMapperArray(userAddresses ?? []);

}

export function deleteUserAddress(userAddressId: string): Promise<any> {
    return deleteData("/user-addresses/" + userAddressId);
}